import { useContext } from 'react'
import { SearchContext } from './search-context'
import ButtonComponent from '../../../atoms/button'
import { buttonVariantOptions } from '../../../atoms/button/constants'
import colorsOptions from '../../../fundamentals/colors-styles/constants'
import { searchVariantsOptions } from '../constants'
import { useIntl } from 'react-intl'

const SearchCancelButton = () => {
  const { formatMessage } = useIntl()
  const { variant, showCancelButton, cancelButtonRef, handleCancel } =
    useContext(SearchContext)

  if (variant !== searchVariantsOptions.MOBILE) {
    return null
  }

  return (
    <ButtonComponent
      variant={buttonVariantOptions.GHOST}
      onClick={handleCancel}
      ref={cancelButtonRef}
      style={{
        position: 'absolute',
        right: 0,
        opacity: showCancelButton ? 1 : 0,
        transition: 'opacity 0.8s ease',
        pointerEvents: showCancelButton ? 'auto' : 'none',
        padding: '0.5rem',
        color: colorsOptions.greys['grey-70']
      }}
    >
      {formatMessage({ id: 'cancel' })}
    </ButtonComponent>
  )
}

export default SearchCancelButton
